import { render, staticRenderFns } from "./SelectNumber.vue?vue&type=template&id=2fd3561d&scoped=true&"
import script from "./SelectNumber.vue?vue&type=script&lang=js&"
export * from "./SelectNumber.vue?vue&type=script&lang=js&"
import style0 from "./SelectNumber.vue?vue&type=style&index=0&id=2fd3561d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3561d",
  null
  
)

component.options.__file = "SelectNumber.vue"
export default component.exports